import { AprOrApyType } from '@/shared/types/AprOrApyType';

export function extractAprOrApy<
  T extends { apr?: number | null | undefined; apy?: number | null | undefined },
>(
  priority: AprOrApyType,
  data?: T,
): {
  value: number;
  type: AprOrApyType;
} | null {
  const valueExists = data?.apr != null || data?.apy != null;

  if (!valueExists) {
    return null;
  }

  if (priority === 'APY') {
    const value = data.apy ?? data.apr ?? 0;
    const type = data.apy != null ? 'APY' : 'APR';
    return {
      value,
      type,
    };
  } else {
    const value = data.apr ?? data.apy ?? 0;
    const type = data.apr != null ? 'APR' : 'APY';
    return {
      value,
      type,
    };
  }
}
